import React, { useState } from 'react';
import Table from '../common/Table';
import tableConfig, { data } from './config';
import { Typography } from '@material-ui/core';
import { Chart } from 'react-google-charts';

const Sales = (props) => {
  const classes = props.classes;
  let config = tableConfig(props);
  const onView = () => { props.onView() }

  return (<div>
    <div className={classes.tabRoot}>
      <h3 className="mb-4"> <strong>Sales</strong> </h3>
      <Chart
      width={'100%'}
      height={'300px'}
      chartType="Bar"
      loader={<div>Loading Chart</div>}
      data={[
        ['Year', 'dummy1', 'Sales', 'dummy2'],
        ['2014', 0, 1000, 0],
        ['2015', 0, 1170, 0],
        ['2016', 0,  660, 0],
        ['2017', 0, 500, 0],
      ]}
      hAxis={{
        title: ''
      }}
      yAxis={{
        title: ''
      }}
      options={{
        // Material design options
        legend: { position: 'none' },
        bar: {groupWidth: "50%"},
        colors: ['#f58634', '#409443'],
      }}
      // For tests
      rootProps={{ 'data-testid': '2' }}
    />
    </div>
  </div>)
};

export default Sales;
